<template>
  <div class="pointsucceed">
    <!-- <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="购买成功" fixed >
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: 25px" @click="goBack"></van-icon>
      <van-icon slot="right" class="iconfont icon-zhankai" @click="onClickRight()"></van-icon>
    </van-nav-bar> -->
    <GlobTopNav title="购买成功"></GlobTopNav>
    <div class="van-content">
      <div class="title">
        <van-icon style="color: #00CF36!important;font-size: 0.88rem!important;" name="checked" />
        <p class="ft16">积分购买成功！</p>
      </div>
      <van-cell-group>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">订单编号：{{ datas.order_sn }}</span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">购买积分：{{datas.point}}{{unit}}</span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">交易金额：{{ datas.money }} 元
            </span>
          </template>
        </van-cell>
        <van-cell>
          <template slot="title">
            <span class="van-cell-text">下单时间：{{ datas.add_time}}</span>
          </template>
        </van-cell>
      </van-cell-group>
        <van-button @click="godetail()" style="font-size: .35rem;width: 90%;margin-left: 5%;margin-top: 30px;border-radius: 6px" class="theme-bd theme-bg">
          查看购买记录
        </van-button>
        <van-button @click="gocart()" class="go-back" style="font-size: .35rem;width: 90%;margin-top:10px;margin-left: 5%;border-radius: 6px;border: 1px solid #ddd;margin-bottom: 20px;color:#000;">
          返回{{$common.cardName().name}}
        </van-button>
        <van-button @click="goHome()" class="go-back" style="font-size: .35rem;width: 90%;margin-top:10px;margin-left: 5%;border-radius: 6px;border: 1px solid #ddd;margin-bottom: 20px;color:#000;">
          返回首页
        </van-button>
    </div>
    <!--<footer-nav></footer-nav>-->
  </div>
</template>

<script>
import FooterNav from "@/components/footernav";
import TopNav from "../../components/topnav";
export default {
  name: "pointsucceed",
  components: {
    FooterNav,
    TopNav
  },

  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    }
  },
  data() {
    return {
      id: this.$route.query.id,
      datas: ""
    };
  },
  methods: {
    godetail: function() {
      this.$router.push({ path: "/user/buypoints/detail" });
    },
    goHome: function() {
      this.$router.push({ path: "/" });
    },
    gocart: function() {
      this.$router.push({ path: "/user/cart" });
    },
    goBack: function() {
      this.$router.push({ path: "/user" });
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    time: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    getDatas: function() {
      var mallid = localStorage.getItem("mallid");
      var isUser = localStorage.getItem("BLHuser");
      this.$api.get(
        "user/wechat/buyinfo",
        { id_example: mallid, token_user: isUser, id: this.id },
        res => {
          if (res.data.code == "100") {
            this.datas = res.data.data;
          } else {
            this.$toast(res.data.message);
          }
        }
      );
    }
  },
  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less" scoped>
.pointsucceed {
  .van-cell-text {
    color: #999;
  }
  .ft16 {
    font-size: 0.36rem;
  }
  .title {
    background: #fff;
    margin-bottom: 10px;
    .van-icon {
      font-size: 0.88rem;
      margin-bottom: 10px;
    }
  }
  .van-cell-group {
    padding: 10px 0;
    background: #fff;
  }
  .van-cell {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
  .title {
    text-align: center;
    padding: 20px 0;
    font-size: 2rem;
  }
  .title .van-icon {
    vertical-align: middle;
    margin-right: 5px;
  }
  .title span {
    vertical-align: middle;
  }

  .go-back {
    .van-button__content {
      color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/affirmorder/pointsucceed.vue